import {useEffect, useMemo, useState} from "react";
import httpReq from "../../services/httpReq";
import MapVideoTracks from "./MapVideoTracks";
import MapVideoReports from "./MapVideoReports";
import {useDispatch, useSelector} from "react-redux";
import {toggleVideoOpen} from "../../store/reducers/projects";
import * as lod from "lodash";

const MapProjectLayer = ({project,tagValuesIds}) => {
    const dispatch = useDispatch();

    const localStorageProjects = useSelector((state) => state.projects.openLocalStorage);

    const [isLoaded, setIsLoaded] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [videos, setVideos] = useState([]);

    useEffect(() => {
        if (isLoading || isLoaded) return;
        setIsLoading(true);
        httpReq(`/Video/GetListByProject/${project.id}`, 'GET', null, true).then(res => {
            if (!res || res.responseAnyError) return;
            if (res.responseAnyError) return
            const items = [...res.responseData].map((item, k) => {
                const foundProject = (localStorageProjects && localStorageProjects.length > 0) ? localStorageProjects.find(p => p.id === project.id) : null;
                const localProject = { ...project, ...foundProject };
                const foundVideo = localProject.video ? localProject.video.find(v => v.id === item.id) : null;
                item.color = project.color;
                if (!foundVideo) {
                    item = {...item, isOpen: foundProject.isOpen};
                    dispatch(toggleVideoOpen({project: project, video: item}));
                }
                else {
                    item = {...item, isOpen: foundVideo.isOpen};
                }
                return item;
            });
            const p = lod.orderBy(items, ['title'], 'asc')
            setVideos(p);
            setIsLoading(false);
        });
        setIsLoaded(true);
    }, [isLoaded])

    useEffect(() => {
        if (!videos || videos.length === 0) return;
        const items = videos.map((item, k) => {
            const foundProject = (localStorageProjects && localStorageProjects.length > 0) ? localStorageProjects.find(p => p.id === project.id) : null;
            const localProject = { ...project, ...foundProject };
            const foundVideo = localProject.video ? localProject.video.find(v => v.id === item.id) : null;
            item.color = project.color;
            if (foundVideo) item = {...item, isOpen: foundVideo.isOpen};
            return item;
        });
        setVideos(items);
    }, [localStorageProjects])

    return (
        <>
            {videos && videos.length>=0 && videos.filter(v=> v.isOpen===true).map((video) => {
                return (
                    <>
                        <MapVideoTracks key={'key-video-tracks-' + video.id} project={project} video={video}/>
                        <MapVideoReports tagValuesIds={tagValuesIds} key={'key-video-reports-' + video.id} project={project} video={video}/>

                    </>
                )
            })}
        </>
    )
}
export default MapProjectLayer;